import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function ConfirmStopManagedRunDialog({
  open,
  loading,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="sm">
      <DialogTitle>Stop managed-run operation?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The operator chat will stop scheduled checks and event-triggered
          management for this workflow run. This will not cancel or terminate
          the workflow session. The chat transcript will remain available.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button color="error" onClick={onConfirm} disabled={loading}>
          Stop management
          {loading && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
